import { Dom } from './dom'

export class Accordion {
  static open = 'open'
  static closed = 'closed'
  static statusAttribute = 'data-accordion-status'

  constructor(callback) {
    this.dom = new Dom()
    this.callback = callback
  }

  mount = () => {
    if (this.dom.accordions) {
      this.dom.accordions.forEach(accordion => {
        this.dom.accordionItems(accordion).forEach(element => {
          element.addEventListener('click', this._toggleItem)
        })
      })
    }
  }

  _toggleItem = event => {
    const element = event.target.parentElement

    if (element.dataset.accordionStatus === Accordion.open) {
      this._hideItem(element)
    } else {
      this._hideItem(element)
      this._openItem(element)
    }

    if (this.callback) {
      this.callback(event)
    }
  }

  _hideItem = element => {
    const activeElement = this.dom.activeElement(element)

    if (activeElement) {
      activeElement.setAttribute(Accordion.statusAttribute, Accordion.closed)
    }
  }

  _openItem = element => element.setAttribute(Accordion.statusAttribute, Accordion.open)
}
